const getHeaders = (token) => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  Authorization: `Bearer ${token}`,
})

const noAuthHeader = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
}

const getSurveyToken = async (token, agentId) => {
  const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/auth`, {
    method: 'POST',
    headers: getHeaders(token),
    body: JSON.stringify({
      agentId,
    }),
  })
  const survey_token = await response.text()

  return survey_token
}

const getVisitorToken = async (token, survey_id) => {
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/auth/visitor`,
    {
      method: 'POST',
      headers: getHeaders(token),
      body: JSON.stringify({ survey_id }),
    }
  )
  const visitor_token = await response.text()

  return visitor_token
}

const getSurveys = async (token) => {
  const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/surveys`, {
    headers: getHeaders(token),
  })
  const data = await response.json()

  return data
}

const deleteSurvey = async (id, token) => {
  const { status } = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/surveys/${id}`,
    {
      method: 'DELETE',
      headers: getHeaders(token),
    }
  )

  return status
}

const postSurvey = async (structure, name, token) => {
  const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/surveys`, {
    method: 'POST',
    headers: getHeaders(token),
    body: JSON.stringify({
      name,
      structure,
    }),
  })
  const data = await response.text()

  return data
}

const activateSurvey = async (id, token) => {
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/surveys/${id}/active`,
    {
      method: 'PATCH',
      headers: getHeaders(token),
    }
  )
  const data = await response.text()

  return data
}

const deactivateSurvey = async (id, token) => {
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/surveys/${id}/inactive`,
    {
      method: 'PATCH',
      headers: getHeaders(token),
    }
  )
  const data = await response.text()

  return data
}

const activateSavingAttributes = async (id, token) => {
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/surveys/${id}/activate_setting_attributes`,
    {
      method: 'PATCH',
      headers: getHeaders(token),
    }
  )
  const data = await response.text()

  return data
}

const deactivateSavingAttributes = async (id, token) => {
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/surveys/${id}/inactivate_setting_attributes`,
    {
      method: 'PATCH',
      headers: getHeaders(token),
    }
  )
  const data = await response.text()

  return data
}

const getResponse = async (survey_id, token) => {
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/response/${survey_id}`,
    {
      headers: getHeaders(token),
    }
  )
  const data = await response.json()

  return data
}

const sendResponse = async (token, response) => {
  const apiResponse = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/response`,
    {
      method: 'POST',
      headers: getHeaders(token),
      body: JSON.stringify({ response }),
    }
  )
  const status = await apiResponse.text()

  return status
}

const getPublicSurvey = async (token) => {
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/public/survey/${token}`,
    {
      method: 'GET',
    }
  )

  if (response.status === 405) {
    return 'SURVEY_INACTIVE'
  }

  const data = await response.text()

  return data
}

const sendPublicResponse = async (token, response, ipAdress, paramsField) => {
  let body = {
    response,
  }

  if (ipAdress) {
    body.ipAdress = ipAdress
  }

  if (paramsField && Object.keys(paramsField).length > 0) {
    body.paramsField = paramsField
  }

  const apiResponse = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/public/response/${token}`,
    {
      method: 'POST',
      body: JSON.stringify(body),
      headers: noAuthHeader,
    }
  )
  const status = await apiResponse.text()

  return status
}

const createPublicToken = async (token, id) => {
  const apiResponse = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/public/token`,
    {
      method: 'POST',
      body: JSON.stringify({ survey_id: id }),
      headers: getHeaders(token),
    }
  )
  const publicToken = await apiResponse.text()

  return publicToken
}

const getIPAddress = async () => {
  const response = await fetch(`${process.env.REACT_APP_IP_RECOGNIZE_API}`)
  const data = await response.text()

  return data
}

const createAttributeName = async (token, id, question_index, name) => {
  const apiResponse = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/surveys/${id}/attribute_name`,
    {
      method: 'POST',
      body: JSON.stringify({ name, question_index }),
      headers: getHeaders(token),
    }
  )
  const response = await apiResponse.text()

  return response
}

const deleteAttributeName = async (token, id, question_index) => {
  const apiResponse = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/surveys/${id}/attribute_name`,
    {
      method: 'DELETE',
      body: JSON.stringify({ question_index }),
      headers: getHeaders(token),
    }
  )
  const response = await apiResponse.text()

  return response
}

const createExternalServiceUrl = async (token, id, url) => {
  const apiResponse = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/surveys/${id}/external_service_url`,
    {
      method: 'PUT',
      body: JSON.stringify({ url }),
      headers: getHeaders(token),
    }
  )
  const response = await apiResponse.text()

  return response
}

const sendResponseToExternalService = async (
  survey_response,
  survey_name,
  service_url
) => {
  const apiResponse = await fetch(service_url, {
    method: 'POST',
    body: JSON.stringify({
      response: survey_response,
      survey: { name: survey_name },
    }),
  })
  const response = await apiResponse.text()

  return response
}

const updateStaticContent = async (token, id, body) => {
  const apiResponse = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/surveys/${id}/customize_static_content`,
    {
      method: 'PUT',
      body: JSON.stringify(body),
      headers: getHeaders(token),
    }
  )
  const response = await apiResponse.text()

  return response
}

const addNewGroupingLabel = async (token, id, body) => {
  const apiResponse = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/settings/${id}/add_new_grouping_label`,
    {
      method: 'POST',
      body: JSON.stringify(body),
      headers: getHeaders(token),
    }
  )
  const response = await apiResponse.text()

  return response
}

const assignLabelToSurvey = async (token, id, body) => {
  const apiResponse = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/surveys/${id}/grouping_label`,
    {
      method: 'POST',
      body: JSON.stringify(body),
      headers: getHeaders(token),
    }
  )
  const response = await apiResponse.text()

  return response
}

const removeLabelFromSurvey = async (token, id, body) => {
  const apiResponse = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/surveys/${id}/grouping_label`,
    {
      method: 'DELETE',
      body: JSON.stringify(body),
      headers: getHeaders(token),
    }
  )
  const response = await apiResponse.text()

  return response
}

const fetchSettings = async (token) => {
  const apiResponse = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/settings`,
    {
      method: 'GET',
      headers: getHeaders(token),
    }
  )
  const response = await apiResponse.text()

  return response
}

const editSurveyQuestion = async (token, surveyId, questionId, question) => {
  const apiResponse = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/surveys/${surveyId}/question/${questionId}/update`,
    {
      method: 'PUT',
      body: JSON.stringify({ question }),
      headers: getHeaders(token),
    }
  )
  const response = await apiResponse.text()

  return response
}

const updateSurveySentStatistic = async (token, id) => {
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/surveys/${id}/increment_sent_statistic`,
    {
      method: 'PATCH',
      headers: getHeaders(token),
    }
  )
  const data = await response.text()

  return data
}

const deleteSurveyResponse = async (token, survey_id, response_id) => {
  const response = await fetch(
    `${process.env.REACT_APP_SERVER_URL}/surveys/${survey_id}/response/${response_id}`,
    {
      method: 'DELETE',
      headers: getHeaders(token),
    }
  )
  const data = await response.text()

  return data
}

export default {
  getSurveyToken,
  getSurveys,
  deleteSurvey,
  postSurvey,
  activateSurvey,
  deactivateSurvey,
  getResponse,
  getVisitorToken,
  sendResponse,
  getPublicSurvey,
  sendPublicResponse,
  createPublicToken,
  getIPAddress,
  activateSavingAttributes,
  deactivateSavingAttributes,
  createAttributeName,
  deleteAttributeName,
  createExternalServiceUrl,
  sendResponseToExternalService,
  updateStaticContent,
  addNewGroupingLabel,
  fetchSettings,
  assignLabelToSurvey,
  removeLabelFromSurvey,
  editSurveyQuestion,
  updateSurveySentStatistic,
  deleteSurveyResponse,
}
